import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EventService } from '@ncs/ncs-lib';

@Injectable({
  providedIn: 'root', // or specify a different provider scope if needed
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private router: Router, private eService: EventService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Request Interceptor
    const modifiedReq = req.clone({
      // headers: req.headers.set('Authorization', 'Bearer YOUR_TOKEN_HERE'),
      // Add more headers if needed
    });

    // Response Interceptor
    return next.handle(modifiedReq).pipe(
      tap((event) => {
        // put success response logic here
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (
            error.error &&
            error.error.error === 'OOPS! Your session has been expired'
          ) {
            //alert("Your session has expired. Please log in again.");                 
            this.eService.sessionEnd('OOPS your session is expired');
            //this.router.navigate(['/login/'+accessKey]); // Redirect to login page
          }
        } else {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            errorMessage = `Client-side error: ${error.error.message}`;
          } else {
            errorMessage = `Server-side error: ${error.status} ${error.message}`;
          }
          console.error(errorMessage);
          //alert(errorMessage);
        }

        // Return an empty observable to complete the request without rethrowing the error
        return new Observable<HttpEvent<any>>();
      })
    );
  }
}
